/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleContactFormState.js'
import mutations from './moduleContactFormMutations.js'
import actions from './moduleContactFormActions.js'
import getters from './moduleContactFormGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
